<template>
  <ca-action-icon color="danger" :hint="hint ? hint : $t('common.delete')" icon="trash-can-outline" />
</template>

<script>
import CaActionIcon from "@/views/components/actions-icons/ActionIcon";

export default {
  name: "CaDeleteActionIcon",
  components: { CaActionIcon },
  props: {
    hint: {
      type: String,
      default: null
    }
  }
};
</script>
